<section class="c2">
  <div class="container c2">
    <div class="title c2">
      <small>{{ miniTitles[lang] || miniTitles['en'] }}</small>
      <h2>{{ titles[lang][game] || titles['en'][game] }}</h2>
    </div>

    <div class="features c2">
      <div *ngFor="let feature of (features[lang]?.[game] || features['en'][game])" class="card c2">
        <div class="ico c2">
          <i class="uil uil-user-exclamation" [style.color]="feature.color">
            <img style="width: 36px;" [lazyLoad]="'https://cdn.ggboost.com/images' + feature.icon" [alt]="feature.title + ' icon'">
          </i>
        </div>
        <div>
          <h3>{{feature.title}}</h3>
          <p>{{feature.description}}</p>
        </div>
      </div>
    </div>
  </div>
</section>